<template>
	<table
		class="
			b-table
			table table-bordered
			bg-white
			b-table-stacked-md
			table-sm table-striped
			mb-3
		"
		v-if="!item.endereco.situacao_rua"
	>
		<tbody>
			<tr>
				<td colspan="2">
					Logradouro:
					<strong>
						{{ item.endereco.logradouro.tipo }}
						{{ item.endereco.logradouro.nome_logradouro }}
					</strong>
				</td>
			</tr>
			<tr>
				<td>
					Número:
					<strong>{{ item.endereco.numero_endereco }}</strong>
				</td>
				<td>
					Bairro/Localidade:
					<strong>
						{{
							item.endereco.localidade ? item.endereco.localidade.nome_localidade : ""
						}}</strong
					>
				</td>
			</tr>
			<tr>
				<td>
					CEP:
					<strong>{{ item.endereco.logradouro.cep }}</strong>
				</td>
				<td>
					Complemento:
					<strong>
						{{ item.endereco.complemento_endereco }}
					</strong>
				</td>
			</tr>
			<tr>
				<td>
					Ponto de Referência:
					<strong>
						{{ item.endereco.referencia_endereco }}
					</strong>
				</td>
				<td>
					Endereço de Acolhimento institucional?
					<strong v-if="item.endereco.abrigo"> SIM </strong>
					<strong v-else> NÃO </strong>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	props: ["item"],
};
</script>